import {gql} from "@apollo/client";

export default gql`
  mutation editManagerByEmployerId($data: EmployerManagerInput!) {
    editManagerByEmployerId(data: $data){
      id
    }
  }
`;
